module.exports = __webpack_public_path__ + "fonts/VetoSansCond-LightItalic.37e090f4.woff2";